import { FormattedMessage, useIntl } from 'react-intl';

import { useFeature } from '@xing-com/hub';
import { IconButterflyMono } from '@xing-com/icons';

import { Styled } from './share-tab-header.styles';

export const ShareTabHeader: React.FC = () => {
  const { formatMessage } = useIntl();
  const isPremium = useFeature('isPremium', false);

  return (
    <Styled.Placebo>
      <Styled.Header $isPremium={isPremium}>
        <Styled.Logo href="/" title={formatMessage({ id: 'A11Y_LOGO' })}>
          <IconButterflyMono width={48} height={48} />
        </Styled.Logo>
        <Styled.Logout href="/login/logout">
          <FormattedMessage id="VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT" />
        </Styled.Logout>
      </Styled.Header>
    </Styled.Placebo>
  );
};
